import { render, staticRenderFns } from "./Protocolos.vue?vue&type=template&id=e08df0b2&scoped=true&"
import script from "./Protocolos.vue?vue&type=script&lang=js&"
export * from "./Protocolos.vue?vue&type=script&lang=js&"
import style0 from "./Protocolos.vue?vue&type=style&index=0&id=e08df0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08df0b2",
  null
  
)

export default component.exports